import { Component } from "@/types"
import { Icon } from "@/ui/atoms/media/Icon"
import { Title } from "@/ui/atoms/type/Title"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { cx } from "@/utils/cx"
import { tx } from "@/utils/tx"

export const COMPONENT_NAME = "testimonialCard"

export const presets = {}

export interface Props extends Component {
  quote: string
  author: string
  credit: string
}

export function TestimonialCard({
  quote,
  author,
  credit,
  className,
  testId = COMPONENT_NAME,
}: Props) {
  return (
    <article
      className={cx(`p-6 rounded-tl-[2.5em] rounded-br-[2.5em] bg-white`, className)}
      data-test={testId}
    >
      <div className={`space-y-2`}>
        <Icon name="quoteLg" className="text-teal-500" testId={tx(testId, "icon")} />

        <BodyText
          size="md"
          className="italic text-text-secondary font-light"
          testId={tx(testId, "quote")}
        >
          {quote}
        </BodyText>

        <div className="flex gap-2 items-center pt-1">
          <div className="pt-1">
            <Title size="xs" className="text-[14px]" testId={tx(testId, "author")}>
              {author}
            </Title>
            <BodyText size="sm" className="" testId={tx(testId, "credit")}>
              {credit}
            </BodyText>
          </div>
        </div>
      </div>
    </article>
  )
}
